const logoMap = [
	{
		type: 'bankSquare',
		logo: [
			{
				code: '037',
				url: require('@/assets/logo/bank/bank-agi.png'),
			},
			{
				code: '022',
				url: require('@/assets/logo/bank/bank-bca.png'),
			},
			{
				code: '014',
				url: require('@/assets/logo/bank/bank-bca.png'),
			},
			{
				code: '002',
				url: require('@/assets/logo/bank/bank-bri.png'),
			},
			{
				code: '008',
				url: require('@/assets/logo/bank/bank-mandiri.png'),
			},
			{
				code: '022',
				url: require('@/assets/logo/bank/bank-cimb.png'),
			},
			{
				code: '451',
				url: require('@/assets/logo/bank/bank-bsi.png'),
			}
		]
	}
]

export const logoSearch = (code, type = undefined) => {
	let urlLogo = ''

	// logo bank
	if (type === 'bankSquare') {
		const bank = logoMap.find(item => item.type === 'bankSquare')
		const bankLogo = bank.logo.find(item => item.code === code)
		if (bankLogo) {
			urlLogo = bankLogo.url
		} else {
			urlLogo = ''
		}
	}

	return urlLogo
}